import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homepage';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-20 mb-14">
          <div className="md:w-2/5">
            <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase whitespace-nowrap">
              探索分类
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mt-3">
              发现属于你的
              <br />
              漫画世界
            </h2>
            <p className="text-sm text-foreground-500 mt-4 leading-relaxed">
              八大分类，覆盖所有韩漫类型，精准找到你的最爱
            </p>
          </div>
          <div className="md:w-3/5 grid grid-cols-2 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">
                    {cat.count} 部作品
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg" />
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 rounded-2xl overflow-hidden">
          <Link
            to="/category/fantasy"
            className="md:col-span-2 relative h-56 md:h-64 rounded-xl overflow-hidden group cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20scene%20with%20magical%20landscape%2C%20dreamy%20warm%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20ethereal%20atmosphere%2C%20soft%20pastel%20tones%2C%20clean%20composition%2C%20modern%20digital%20illustration&width=800&height=560&seq=category-fantasy-01&orientation=landscape"
              alt="奇幻冒险漫画"
              title="奇幻冒险 - 韩漫在线分类"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="text-white text-lg font-heading font-bold whitespace-nowrap">奇幻冒险</span>
            </div>
          </Link>
          <Link
            to="/category/romance"
            className="md:col-span-3 relative h-56 md:h-64 rounded-xl overflow-hidden group cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20scene%20with%20couple%20in%20beautiful%20environment%2C%20warm%20golden%20hour%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20soft%20romantic%20atmosphere%2C%20clean%20composition%2C%20modern%20digital%20illustration%20with%20gentle%20pastel%20tones&width=1200&height=560&seq=category-romance-01&orientation=landscape"
              alt="浪漫爱情漫画"
              title="浪漫爱情 - 韩漫在线分类"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="text-white text-lg font-heading font-bold whitespace-nowrap">浪漫爱情</span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}